import { Button } from "@/components/ui/button";
import { ArrowRight, ArrowUp, Mail, Globe } from "lucide-react";
import { useTranslation } from "react-i18next";

const CTASection = () => {
  const { t } = useTranslation();

  const handleBack = () => {
    const heroSection = document.querySelector('.relative.pt-12');
    if (heroSection) {
      heroSection.scrollIntoView({ behavior: 'smooth' });
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  return (
    <section id="contato" className="relative py-24 md:py-32 scroll-mt-24">
      <div className="gradient-line mb-24 md:mb-32" />

      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[300px] rounded-full bg-primary/8 blur-[120px] pointer-events-none" />

      <div className="relative mx-auto max-w-7xl px-6 md:px-8">
        <div className="glass rounded-3xl p-6 sm:p-10 md:p-20 glass-shine animate-glow-pulse">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <button
                onClick={handleBack}
                className="inline-flex items-center gap-2 glass rounded-full px-4 py-2 mb-8 cursor-pointer hover:border-primary/30 transition-all duration-300"
              >
                <ArrowUp className="h-4 w-4 text-muted-foreground hover:text-primary transition-colors" />
                <span className="text-xs font-body text-primary">{t("cta.backToTop")}</span>
              </button>
              <p className="text-sm font-body font-medium text-primary uppercase tracking-wide flex items-center gap-2">
                <span className="led" />
                {t("cta.tag")}
              </p>
              <h2 className="mt-3 text-2xl sm:text-3xl md:text-5xl font-display font-bold tracking-display text-foreground">
                {t("cta.title1")}
                <br />
                <span className="text-primary neon-text">{t("cta.title2")}</span>
              </h2>
              <p className="mt-6 text-lg font-body text-muted-foreground max-w-lg">
                {t("cta.subtitle")}
              </p>

              <div className="mt-8 space-y-4">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center">
                    <Mail className="w-4 h-4 text-primary" />
                  </div>
                  <span className="text-sm font-body text-muted-foreground">
                    {t("cta.email")}
                  </span>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center">
                    <Globe className="w-4 h-4 text-primary" />
                  </div>
                  <span className="text-sm font-body text-muted-foreground">
                    {t("cta.global")}
                  </span>
                </div>
              </div>
            </div>

            <div className="flex flex-col items-center">
              <a href="https://wa.me/5511911266684" target="_blank" rel="noopener noreferrer">
                <Button variant="hero" size="xl" className="w-full sm:w-auto whitespace-nowrap">
                  {t("cta.button")}
                  <ArrowRight className="ml-1 h-4 w-4" />
                </Button>
              </a>
              <p className="mt-4 text-xs font-body text-muted-foreground/60 text-center">
                {t("cta.response")}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
